import { createSelector } from 'reselect';

import { selectFilteredUsers } from 'store/users/selectors';

import { getSystem } from './system.selectors';

export const getRoleUsersIds = createSelector(getSystem, ({ roleUsers }) => roleUsers);

export const getRoleUsers = createSelector(
  [selectFilteredUsers, getRoleUsersIds],
  (users, { currentRoleUsersIds }) =>
    users.map(user => ({
      ...user,
      isBelongToCurrentPageRole: currentRoleUsersIds.includes(user.id),
    })),
);
